import { render, staticRenderFns } from "./left3new.vue?vue&type=template&id=e97a63b6&scoped=true&"
import script from "./left3new.vue?vue&type=script&lang=js&"
export * from "./left3new.vue?vue&type=script&lang=js&"
import style0 from "./left3new.vue?vue&type=style&index=0&id=e97a63b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97a63b6",
  null
  
)

export default component.exports